<template>
  <div class="open-app">
    <touch @tap="openApp">
      <slot></slot>
    </touch>

    <div v-show="showTip" class="lls-open-app-cover">
      <touch class="tip" @tap="closeTip">
        <div class="text">点击右上角，通过浏览器<br/>方式立即打开流利说</div>
        <div class="icon"><img src="https://cdn.llscdn.com/fe-static/lingome-wx/right-up-corner@2x-OWgdzdWl.png"></div>
      </touch>
    </div>

    <iframe v-show="iframeLink" class="open" :src="iframeLink" frameborder="0"></iframe>
  </div>
</template>

<script>
  export default {
    name: 'open-app',
    props: {
      download: {
        type: String,
        default: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.liulishuo.engzo&ckey=CK1381496888882'
      }
    },
    data () {
      return {
        showTip: false,
        iframeLink: ''
      }
    },
    computed: {
      options () {
        return {
          universalLink: this.$store.state.UNIVERSAL_LINK,
          schema: 'lls://navigate',
          path: 'webview',
          params: {
            url: this.$store.state.APP_URL
          }
        }
      }
    },
    methods: {
      openTip () {
        this.showTip = true
      },
      closeTip () {
        this.showTip = false
      },
      isChrome () {
        const isChromium = window.chrome
        const winNav = window.navigator
        const vendorName = winNav.vendor
        const isOpera = winNav.userAgent.indexOf('OPR') > -1
        const isIEedge = winNav.userAgent.indexOf('Edge') > -1
        const isIOSChrome = winNav.userAgent.match('CriOS')

        if (isIOSChrome) {
          return true
        } else if (isChromium && vendorName === 'Google Inc.' && !isOpera && !isIEedge) {
          return true
        }

        return false
      },
      getIOSVersions () {
        // supports iOS 2.0 and later
        // code from https://stackoverflow.com/questions/8348139/detect-ios-version-less-than-5-with-javascript
        if (/iP(hone|od|ad)/.test(navigator.platform)) {
          const v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/)
          return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)]
        }

        return false
      },
      createScheme (options, useUniLink) {
        const { universalLink, schema, path } = options
        const params = options.params || {}
        const kv = Object
          .keys(params)
          .map(k => `${k}=${encodeURIComponent(params[k])}`)
          .join('&')

        const uLinkUrl = kv ? `${universalLink}/${path}?${kv}` : `${universalLink}/${path}`
        const schemaUrl = kv ? `${schema}/${path}?${kv}` : `${schema}/${path}`

        if (useUniLink) {
          return uLinkUrl
        }

        return schemaUrl
      },
      isIOSVersionGE9 () {
        const iosVersions = this.getIOSVersions()
        return /ip(ad|hone|od)/i.test(navigator.userAgent.toLowerCase()) && (iosVersions && iosVersions[0] >= 9)
      },
      isIOS () {
        return /ip(ad|hone|od)/i.test(navigator.userAgent.toLowerCase())
      },
      isWeixin () {
        return /micromessenger/i.test(navigator.userAgent.toLowerCase())
      },
      isAndroid () {
        return /android/i.test(navigator.userAgent.toLowerCase())
      },
      openApp () {
        // 默认跳到下载页
        if (this.download) {
          setTimeout(() => {
            window.location.replace(this.download)
          }, 0)
        }
      }
    }
  }
</script>

<style lang="scss">
  .open-app {
    .open {
      display: none;
    }
    .lls-open-app-cover {
      position: fixed;
      z-index: 999;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background: rgba(0,0,0,.6);
      .tip {
        display: flex;
        justify-content: flex-end;
        padding-right: 30px;
        .text {
          color: #fff;
          font-size: 28px;
          margin-top: 60px;
          margin-right: 40px;
        }
        .icon {
          margin-top: 30px;
          img {
            width: 64px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// OpenApp.vue?f7c04250